"use client"

import React, {useEffect, useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {UnstyledButton} from "@mantine/core";
import {Crete_Round, Fugaz_One, Noto_Sans_TC, Poppins, Rowdies} from 'next/font/google';
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import Footer from "@/app/(index)/footer";
import Bread from "@/app/(index)/bread";
import ChronicleTwContent from "@/app/(index)/chronicle/tw-content";
import ChronicleEnContent from "@/app/(index)/chronicle/en-content";
import {loadChronicle} from "@/service";
import {IChronicle} from "@/form";
import {useMediaQuery} from "@mantine/hooks";

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});
export default function HomePage() {
    const { lang } = useGlobalStateStore();
    // const loadCurrentFontSize = (s: number, m: number, l: number) => {
    //     if(fontSize == 0) return `text-[${s}px]`;
    //     else if(fontSize == 1) return `text-[${m}px]`;
    //     else if(fontSize == 2) return `text-[${l}px]`;
    // }

    const [data, setData] = useState<{[key: number]: IChronicle[]}>({});

    useEffect(() => {
        loadChronicle().then(data => {
            setData(data);
        })
    }, []);
    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>
                {
                    mediaQueryLessSM && (
                        <Bread name_c="關於科政中心 - 大事紀要" name_e="About STPI - History"/>
                    )
                }
                <div
                    className={cx("mx-auto mb-[100px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full mt-[100px] px-[10px]')}>
                    <div
                        className="bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] pb-[45px] text-[#5b5b5b] text-[35px] font-bold">
                        {lang == "tw" ? "大事紀要" : "History"}
                    </div>
                    {lang == "tw" && <ChronicleTwContent data={data}/>}
                    {lang == "en" && <ChronicleEnContent/>}
                </div>
            </div>
            <Footer/>
        </div>
    );
}
